export const NAME_EXCEPTION = 'አልፋ፣ ግርጌ እና የመጠን ቦታ [2, 100] የተፈቀዱት ቁምፊዎች ብቻ ናቸው።'; // 'Alpha, underscore and space of size [2, 100] are only the allowed characters.';

export const REQUIRED_FIELD = 'ይሄ ቦታ ይፈለጋል';

export const DESCRIPTION_EXCEPTION = 'የመጠን ቦታ [2, 1000] የተፈቀዱት ቁምፊዎች ብቻ ናቸው።'; // 'Alpha, underscore and space of size [2, 1000] are only the allowed characters.';

export const PHONE_EXCEPTION = 'በ9 እና በ7 ብቻ ሊጀምር የሚችል ዘጠኝ ርዝመት ያላቸው ቁጥሮች ይፈቀዳሉ።'; // 'Numbers with length of nine which can only start with 9 or 7 is allowed characters.';

export const EMAIL_EXCEPTION = 'ኢሜል ትክክለኛ ኢሜል መሆን አለበት!';

// Invalid username. Your username can only include Amharic letters, spaces, underscores, and numbers. It must be between 2 and 20 characters in length.
export const USERNAME_EXCEPTION =
  'የተጠቃሚ ስምዎ የአማርኛ ፊደሎችን ፣ ቦታዎችን(spaces) ፣ መከለያዎችን(under scores) እና ቁጥሮችን ብቻ ሊያካትት ይችላል። ርዝመት ከ 2 እስከ 20 ቁምፊዎች መሆን አለበት።';

export const PASSWORD_EXCEPTION =
  'የይለፍ ቃል ርዝማኔ በ 8 እና በ 20 ቁምፊዎች መካከል መሆን አለበት, ይህም ቢያንስ አንድ ቁጥር, ትልቅ እና ትንሽ ፊደል እና ልዩ ቁምፊ ይይዛል.'; // 'Password length must be between 8 and 20 characters, which contain at least one number, upper and lower case letter, and special character.';

export const GENDER_EXCEPTION = 'ጾታ ወንድ ወይም ሴት መሆን አለበት';

export const STATUS_EXCEPTION = 'ሁኔታ ንቁ ወይም የታገደ መሆን አለበት።';

export const CHURCH_CATEGORY_EXCEPTION = 'የአጥቢያ አይነት ገዳም፣ አጥቢያ ወይም ካቴድራል መሆን አለበት።';

export const INTERNAL_SERVER_ERROR = 'የውስጥ መቆጣጠርያ ችግር። እባክዎ ቆይተው እንደገና ይሞክሩ፣ ወይም ገጹን አሁን ያድሱ!';

export const DECIMAL_EXCEPTION = 'የብር መጠን ቁጥር መሆን አለበት።';

export const CURRENCY_EXCEPTION = 'ከረንሲ ETB ወይም USD መሆን አለበት።';
